import React from 'react'
import SmartviewSidebar from 'widgets/smartviews/partials/SmartviewSidebar'

export default function SmartviewContainer ({ defaultSmartviewSize = null, children }) {
  return (
    <>
      <SmartviewSidebar defaultSmartviewSize={defaultSmartviewSize} ghost />
      <SmartviewSidebar defaultSmartviewSize={defaultSmartviewSize}>
        {children}
      </SmartviewSidebar>
    </>
  )
}
